import IconWrapper, { IconWrapperProps } from '@repo/ui/src/components/IconWrapper';

const VideoPauseSmall = ({ ...rest }: IconWrapperProps) => {
  return (
    <IconWrapper width="24" height="24" viewBox="0 0 24 24" {...rest}>
      <defs>
        <filter
          x="-100%"
          y="-100%"
          width="300%"
          height="300%"
          filterUnits="objectBoundingBox"
          id="a"
        >
          <feOffset in="SourceAlpha" result="shadowOffsetOuter1" />
          <feGaussianBlur stdDeviation="8" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
          <feColorMatrix
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.64 0"
            in="shadowBlurOuter1"
          />
        </filter>
        <path
          d="M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0Zm0 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2ZM9.333 7c.737 0 1.334.597 1.334 1.333v7.334a1.333 1.333 0 0 1-2.667 0V8.333C8 7.597 8.597 7 9.333 7Zm5.334 0C15.403 7 16 7.597 16 8.333v7.334a1.333 1.333 0 0 1-2.667 0V8.333c0-.736.597-1.333 1.334-1.333Z"
          id="b"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <path fill="none" d="M7 7h10v10H7z" />
        <use fill="#000" filter="url(#a)" xlinkHref="#b" />
        <use fill="#FFF" xlinkHref="#b" />
      </g>
    </IconWrapper>
  );
};

export default VideoPauseSmall;
